'use client';

import { useMemo } from 'react';

import * as projectApi from '@highlight-cp/project-api';

/**
 * @description
 * Hook to get solutions with isDeleted set to false.
 */
export const useGetActiveSolutions = () => {
  const { data: solutions = [], isLoading } = projectApi.useGetSolutionsQuery({});

  const filteredSolutions = useMemo(
    () => solutions.filter((solution) => !solution.isDeleted),
    [solutions],
  );

  return { data: filteredSolutions, isLoading };
};

export default useGetActiveSolutions;
